import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-20">
        <div className="md:col-span-5">
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-5">01 · Qui sommes-nous</div>
          <h2 className="font-display text-4xl md:text-6xl font-light tracking-tighter leading-[1.02]">
            La rigueur.<br />
            Le soin.<br />
            <span className="text-[#FF2800]">L&apos;engagement.</span>
          </h2>
        </div>

        <div className="md:col-span-7 space-y-8 text-lg text-neutral-700 leading-relaxed">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            D.E.S Dépannage est une entreprise strasbourgeoise spécialisée dans le
            <span className="text-black font-semibold"> déménagement</span>, le
            <span className="text-black font-semibold"> débarras</span> et les
            interventions <span className="text-black font-semibold">express</span> dans
            tout le Grand Est et au-delà — partout en Europe.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Nous croyons qu&apos;un déménagement réussi est un déménagement invisible :
            préparé, ponctuel, et sans accroc. Chaque intervention est encadrée par
            une équipe rigoureuse, équipée du matériel adapté à votre volume et à
            vos contraintes.
          </motion.p>

          <div className="grid grid-cols-2 gap-8 pt-8 border-t border-black/10">
            {[
              ["Devis détaillé", "Sans surprise, sous 24h"],
              ["Équipe formée", "Manutention professionnelle"],
              ["Matériel adapté", "Camions, monte-meuble, protection"],
              ["Réactivité", "Disponible 7j/7 · 8h–20h"],
            ].map(([t, d]) => (
              <div key={t}>
                <div className="font-display text-lg font-medium tracking-tight">{t}</div>
                <div className="text-sm text-neutral-500 mt-1">{d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
